"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ArticleBoxArea = _interopRequireDefault(require("../ArticleBoxArea/ArticleBoxArea"));
var _GoBackButton = _interopRequireDefault(require("../GoBackButton/GoBackButton"));
var _TextInput = _interopRequireDefault(require("../../TextInput/TextInput"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/search/24.js"));
var _Pagination = _interopRequireDefault(require("../../Pagination/Pagination"));
var _MultiselectDropdownClient = require("./MultiselectDropdownClient");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-catalog {\n  padding-inline: 0px; }\n  .sia-catalog .filter-container {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 16px; }\n  .sia-catalog .search {\n    position: relative; }\n    .sia-catalog .search svg {\n      position: absolute;\n      right: 8px;\n      top: 32px;\n      cursor: pointer; }\n    .sia-catalog .search label {\n      opacity: 0; }\n    .sia-catalog .search input {\n      padding-right: 42px; }\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(10px); }\n  100% {\n    opacity: 1;\n    transform: translateY(0px); } }\n  .sia-catalog .item {\n    animation: 1s cubic-bezier(0.1, -0.6, 0.2, 0) 0s 1 fadeIn; }\n  .sia-catalog .bx--list-box__menu {\n    visibility: visible !important; }\n\n@media (max-width: 66rem) {\n  .sia-catalog {\n    padding-inline: 16px; }\n    .sia-catalog .filter-container {\n      grid-template-columns: repeat(2, minmax(0, 1fr)); } }\n\n@media (max-width: 42rem) {\n  .sia-catalog .filter-container {\n    grid-template-columns: repeat(1, minmax(0, 1fr)); } }\n\n.articleBox-container .slider-container {\n  padding-bottom: 16px;\n  width: 100%;\n  max-width: 100%;\n  align-self: center;\n  position: relative; }\n  .articleBox-container .slider-container .slick-track {\n    display: flex;\n    align-items: center;\n    height: auto; }\n  .articleBox-container .slider-container .slick-slider {\n    position: relative; }\n  .articleBox-container .slider-container .slick-slider .slick-prev {\n    left: 0px; }\n  .articleBox-container .slider-container .slick-slider .slick-next {\n    right: 0px; }\n  .articleBox-container .slider-container .slick-slide {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    aspect-ratio: 2.389; }\n  .articleBox-container .slider-container .slick-slide > div {\n    height: 100%; }\n  .articleBox-container .slider-container .slick-slide > div > div {\n    height: 100%; }\n  .articleBox-container .slider-container .slick-slide img {\n    object-fit: cover;\n    width: 66rem;\n    max-width: 100%;\n    height: 100%; }\n  .articleBox-container .slider-container .slick-dots {\n    display: none !important; }\n  .articleBox-container .slider-container .slick-arrow {\n    display: none; }\n\n.articleBox-container .main-tag-image {\n  top: 8px;\n  left: 8px;\n  position: absolute;\n  background-color: #fff;\n  color: #000000;\n  border-radius: 12px;\n  padding: 4px 8px 0px 8px;\n  border: 1px solid #000000;\n  width: fit-content;\n  height: 24px;\n  z-index: 5; }\n\n@media (max-width: 66rem) {\n  .articleBox-container .slick-slide {\n    aspect-ratio: 2.113; } }\n\n@media (max-width: 42rem) {\n  .articleBox-container .slick-slide {\n    aspect-ratio: 1.7977; } }\n\n.articleBox-container.one-column .slick-dots {\n  justify-content: center;\n  padding-right: 0px;\n  margin-bottom: 0px;\n  margin-top: 7px;\n  align-items: center;\n  height: 100%;\n  top: 0px;\n  bottom: 0px; }\n\n.articleBox-container.one-column .slick-slide {\n  aspect-ratio: 1.79; }\n";
  const fileName = "SIACatalog_SIACatalog";
  const element = document.querySelector("style[data-sass-component='SIACatalog_SIACatalog']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const SIACatalog = _ref => {
  let {
    history,
    lang,
    translate,
    getArticles,
    getFilters
  } = _ref;
  const location = history.location;
  const [articles, setArticles] = (0, _react.useState)([]);
  const [page, setPage] = (0, _react.useState)(1);
  const [count, setCount] = (0, _react.useState)();
  const [itemsPerPage, setItemsPerPage] = (0, _react.useState)(10);
  const [previousParams, setPreviousParams] = (0, _react.useState)('');
  const query = new URLSearchParams(location.search);
  const defaultSearch = query.get('search') || '';
  const defaultThemenTags = query.get('themenTags')?.split(',') || [];
  const defaultArticleTypes = query.get('articleTypes')?.split(',') || [];
  const defaultAuthors = query.get('authors')?.split(',') || [];
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const [search, setSearch] = (0, _react.useState)(defaultSearch);
  const [themenTags, setThemenTags] = (0, _react.useState)([]);
  const [articleTypes, setArticleTypes] = (0, _react.useState)([]);
  const [authors, setAuthors] = (0, _react.useState)([]);
  const [activeFilters, setActiveFilters] = (0, _react.useState)({});
  const [filters, setFilters] = (0, _react.useState)({
    ...(defaultThemenTags?.length > 0 ? {
      themenTags: defaultThemenTags
    } : {}),
    ...(defaultArticleTypes?.length > 0 ? {
      articleTypes: defaultArticleTypes
    } : {}),
    ...(defaultAuthors?.length > 0 ? {
      authors: defaultAuthors
    } : {})
  });
  const searchArticles = async () => {
    setIsLoading(true);
    let params = `?fulltext=${search || ''}&page=${page}&page_size=${itemsPerPage}`;
    if (filters.themenTags) {
      params += `&main_tag=${filters.themenTags.join(',')}`;
    }
    if (filters.articleTypes) {
      params += `&article_types=${filters.articleTypes.join(',')}`;
    }
    if (filters.authors) {
      params += `&authors=${filters.authors.join(',')}`;
    }
    if (previousParams === params) return;
    setPreviousParams(params);
    const data = await getArticles(params);
    setActiveFilters(data.active_filters);
    setArticles(data.articles);
    setCount(data.count);
    setIsLoading(false);
    changeUrl();
  };
  const searchFilters = async () => {
    const data = await getFilters();
    setThemenTags(data.themen_tags);
    setArticleTypes(data.article_types);
    setAuthors(data.authors);
  };
  (0, _react.useEffect)(() => {
    searchFilters();
  }, []);
  (0, _react.useEffect)(() => {
    searchArticles();
  }, [page, itemsPerPage, filters]);
  const changeUrl = () => {
    const params = new URLSearchParams({
      ...(filters.themenTags?.length > 0 ? {
        themenTags: filters.themenTags.join(',')
      } : {}),
      ...(filters.articleTypes?.length > 0 ? {
        articleTypes: filters.articleTypes.join(',')
      } : {}),
      ...(filters.authors?.length > 0 ? {
        authors: filters.authors.join(',')
      } : {}),
      ...(search ? {
        search: search
      } : {})
    });
    history.replace({
      pathname: location.pathname,
      search: decodeURIComponent(params.toString())
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-catalog"
  }, /*#__PURE__*/_react.default.createElement(_GoBackButton.default, {
    history: history,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-container sia-margin-05-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "search"
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    defaultValue: defaultSearch,
    id: 'search',
    label: 'search',
    name: 'search',
    onChange: event => {
      setSearch(event.target.value);
    },
    placeholder: translate('cms.catalog.search'),
    onKeyDown: e => {
      e.key === 'Enter' && searchArticles();
      if (e?.key === 'Tab') {
        e.preventDefault();
        document.getElementById('themenTags')?.querySelector('button')?.focus();
      }
    },
    onBlur: event => {
      setSearch(event.target.value);
      searchArticles();
    }
  }), /*#__PURE__*/_react.default.createElement(_.default, {
    onClick: searchArticles
  })), /*#__PURE__*/_react.default.createElement(_MultiselectDropdownClient.MultiselectDropdownClient, {
    id: 'themenTags',
    label: translate('cms.catalog.themen'),
    items: themenTags,
    values: filters?.themenTags,
    setValues: values => {
      setFilters({
        ...filters,
        themenTags: values
      });
      setPage(1);
    },
    activeItems: activeFilters?.main_tags,
    onKeyDown: e => {
      if (e?.key === 'Tab') {
        e.preventDefault();
        document.getElementById('articleTypes')?.querySelector('button')?.focus();
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_MultiselectDropdownClient.MultiselectDropdownClient, {
    id: 'articleTypes',
    label: translate('cms.catalog.article-type'),
    items: articleTypes,
    values: filters?.articleTypes,
    setValues: values => {
      setFilters({
        ...filters,
        articleTypes: values
      });
      setPage(1);
    },
    activeItems: activeFilters?.article_types,
    onKeyDown: e => {
      if (e?.key === 'Tab') {
        e.preventDefault();
        document.getElementById('authors')?.querySelector('button')?.focus();
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_MultiselectDropdownClient.MultiselectDropdownClient, {
    id: 'authors',
    label: translate('cms.catalog.author'),
    items: authors,
    values: filters.authors,
    activeItems: activeFilters?.authors,
    setValues: values => {
      setFilters({
        ...filters,
        authors: values
      });
      setPage(1);
    }
  })), articles && articles?.length > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ArticleBoxArea.default, {
    key: articles,
    items: articles,
    lang: lang,
    translate: translate,
    showTitle: false
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-12 sia-padding-02-top"
  }, /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    items: Array.from({
      length: count
    }, (v, i) => i),
    onChange: (newPage, perPageLimit) => {
      setPage(newPage);
      setItemsPerPage(perPageLimit);
    },
    translate: translate,
    page: page
  }))) : !isLoading && /*#__PURE__*/_react.default.createElement("h3", {
    className: "sia-text-12 sia-padding-05-bottom"
  }, translate('cms.catalog.empty')));
};
var _default = exports.default = SIACatalog;